var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { style: { height: _vm.tableHeight } },
    [
      _c(
        "el-table",
        {
          directives: [
            {
              name: "el-table-infinite-scroll",
              rawName: "v-el-table-infinite-scroll",
              value: _vm.table_config.loadList,
              expression: "table_config.loadList",
            },
          ],
          ref: "table",
          staticClass: "scpc-task-table",
          staticStyle: { width: "100%" },
          attrs: {
            "row-key": _vm.getRowKeys,
            data: _vm.table_config.tableData,
            "header-cell-style": {
              background: "#f9f9f9",
              fontSize: "16px",
            },
            "row-style": { height: "38" },
            "row-class-name": _vm.tableRowClassName,
            lazy: "",
            load: _vm.loadChiTask,
            "tree-props": { children: "children", hasChildren: "hasChildren" },
            border: "",
            height: "100%",
          },
          on: {
            "row-click": _vm.rowFun,
            "header-dragend": _vm.headerDragend,
            "selection-change": _vm.changeBox,
          },
        },
        [
          _c(
            "div",
            {
              staticClass: "empty",
              staticStyle: { display: "none" },
              attrs: { slot: "empty" },
              slot: "empty",
            },
            [_vm._v(" 暂无数据 ")]
          ),
          _vm.checkbox
            ? _c("el-table-column", { attrs: { type: "selection" } })
            : _vm._e(),
          _vm._l(_vm.table_config.thead, function (header, index) {
            return _c("el-table-column", {
              key: index,
              attrs: {
                prop: header.prop,
                "min-width": header.width,
                fixed: header.fixed,
              },
              scopedSlots: _vm._u(
                [
                  {
                    key: "header",
                    fn: function () {
                      return [
                        _c(
                          "div",
                          {
                            staticStyle: {
                              display: "flex",
                              "align-items": "center",
                              "justify-content": "space-between",
                            },
                          },
                          [_c("span", [_vm._v(_vm._s(header.label))])]
                        ),
                      ]
                    },
                    proxy: true,
                  },
                  {
                    key: "default",
                    fn: function (scope) {
                      return [
                        header.prop === "taskname" && _vm.tab === "todoTask"
                          ? _c(
                              "div",
                              { staticClass: "scope-content" },
                              [
                                scope.row.taskType === "1"
                                  ? _c(
                                      "el-tooltip",
                                      {
                                        attrs: {
                                          effect: "dark",
                                          content:
                                            scope.row.nodeName +
                                            "-" +
                                            scope.row.taskname,
                                          placement: "bottom",
                                          "popper-class": "texttooltip",
                                          "open-delay": 500,
                                        },
                                      },
                                      [
                                        _c(
                                          "span",
                                          { staticClass: "scope-content-text" },
                                          [
                                            _vm._v(
                                              " " +
                                                _vm._s(scope.row.nodeName) +
                                                " - " +
                                                _vm._s(scope.row.taskname) +
                                                " "
                                            ),
                                          ]
                                        ),
                                      ]
                                    )
                                  : _c(
                                      "el-tooltip",
                                      {
                                        attrs: {
                                          effect: "dark",
                                          content: scope.row.taskname,
                                          placement: "bottom",
                                          "popper-class": "texttooltip",
                                          "open-delay": 500,
                                        },
                                      },
                                      [
                                        _c(
                                          "span",
                                          { staticClass: "scope-content-text" },
                                          [
                                            _vm._v(
                                              " " +
                                                _vm._s(scope.row.taskname) +
                                                " "
                                            ),
                                          ]
                                        ),
                                      ]
                                    ),
                                _c(
                                  "span",
                                  { staticClass: "scpc-operate-icon" },
                                  [
                                    scope.row.overdueFlag == 1
                                      ? _c(
                                          "span",
                                          { staticClass: "task_within" },
                                          [_vm._v("逾")]
                                        )
                                      : _vm._e(),
                                    scope.row.collectFlag == "1"
                                      ? _c("span", [
                                          _c("i", {
                                            directives: [
                                              {
                                                name: "show",
                                                rawName: "v-show",
                                                value:
                                                  scope.row.collectFlag == 1,
                                                expression:
                                                  "scope.row.collectFlag == 1",
                                              },
                                            ],
                                            staticClass:
                                              "iconfont icon-shoucang1",
                                            staticStyle: {
                                              color: "#ffb83e",
                                              "margin-right": "12px",
                                            },
                                          }),
                                        ])
                                      : _vm._e(),
                                    scope.row.milestone === "1"
                                      ? _c(
                                          "span",
                                          { staticStyle: { padding: "0 6px" } },
                                          [
                                            scope.row.milestone == "1"
                                              ? _c("i", {
                                                  staticClass:
                                                    "iconfont icon-lichengbei-qizhi drawer_icon",
                                                  staticStyle: {
                                                    color: "#2878ff",
                                                  },
                                                })
                                              : _vm._e(),
                                          ]
                                        )
                                      : _vm._e(),
                                    scope.row.taskType === "1"
                                      ? _c("i", {
                                          staticClass:
                                            "iconfont icon-liuchengrenwu liuchen_icon",
                                          staticStyle: {
                                            color: "rgba(28, 106, 235, 1)",
                                            padding: "0 6px",
                                            cursor: "pointer",
                                          },
                                          on: {
                                            click: function ($event) {
                                              $event.stopPropagation()
                                              return _vm.config.figureFun(
                                                scope.row
                                              )
                                            },
                                          },
                                        })
                                      : _vm._e(),
                                  ]
                                ),
                              ],
                              1
                            )
                          : header.prop === "taskname" && _vm.tab !== "todoTask"
                          ? _c(
                              "div",
                              { staticClass: "scope-content" },
                              [
                                _c(
                                  "el-tooltip",
                                  {
                                    attrs: {
                                      effect: "dark",
                                      content: scope.row.taskname,
                                      placement: "bottom",
                                      "popper-class": "texttooltip",
                                      "open-delay": 500,
                                    },
                                  },
                                  [
                                    _c(
                                      "span",
                                      { staticClass: "scope-content-text" },
                                      [
                                        _vm._v(
                                          " " + _vm._s(scope.row.taskname) + " "
                                        ),
                                      ]
                                    ),
                                  ]
                                ),
                                _c(
                                  "span",
                                  { staticClass: "scpc-operate-icon" },
                                  [
                                    scope.row.overdueFlag == 1
                                      ? _c(
                                          "span",
                                          { staticClass: "task_within" },
                                          [_vm._v("逾")]
                                        )
                                      : _vm._e(),
                                    scope.row.collectFlag == "1"
                                      ? _c("span", [
                                          _c("i", {
                                            directives: [
                                              {
                                                name: "show",
                                                rawName: "v-show",
                                                value:
                                                  scope.row.collectFlag == 1,
                                                expression:
                                                  "scope.row.collectFlag == 1",
                                              },
                                            ],
                                            staticClass:
                                              "iconfont icon-shoucang1",
                                            staticStyle: {
                                              color: "#ffb83e",
                                              "margin-right": "12px",
                                            },
                                          }),
                                        ])
                                      : _vm._e(),
                                    scope.row.milestone === "1"
                                      ? _c(
                                          "span",
                                          { staticStyle: { padding: "0 6px" } },
                                          [
                                            scope.row.milestone == "1"
                                              ? _c("i", {
                                                  staticClass:
                                                    "iconfont icon-lichengbei-qizhi drawer_icon",
                                                  staticStyle: {
                                                    color: "#2878ff",
                                                  },
                                                })
                                              : _vm._e(),
                                          ]
                                        )
                                      : _vm._e(),
                                    scope.row.taskType === "1"
                                      ? _c("i", {
                                          staticClass:
                                            "iconfont icon-liuchengrenwu liuchen_icon",
                                          staticStyle: {
                                            color: "rgba(28, 106, 235, 1)",
                                            padding: "0 6px",
                                            cursor: "pointer",
                                          },
                                          on: {
                                            click: function ($event) {
                                              $event.stopPropagation()
                                              return _vm.config.figureFun(
                                                scope.row
                                              )
                                            },
                                          },
                                        })
                                      : _vm._e(),
                                  ]
                                ),
                              ],
                              1
                            )
                          : header.type === "11"
                          ? _c(
                              "div",
                              {
                                staticStyle: {
                                  display: "flex",
                                  overflow: "hidden",
                                  "align-items": "center",
                                  "text-overflow": "ellipsis",
                                  "white-space": "nowrap",
                                },
                              },
                              [
                                header.sysFlag === "1"
                                  ? _c(
                                      "div",
                                      {
                                        staticStyle: {
                                          display: "flex",
                                          "align-items": "center",
                                        },
                                      },
                                      [
                                        _c(
                                          "div",
                                          {
                                            staticClass: "scpc-operate-photos",
                                          },
                                          [
                                            _c(
                                              "div",
                                              {
                                                staticStyle: {
                                                  display: "flex",
                                                  width: "6px",
                                                },
                                              },
                                              _vm._l(
                                                scope.row[header.prop],
                                                function (item1, index) {
                                                  return _c(
                                                    "div",
                                                    {
                                                      key: index,
                                                      staticClass:
                                                        "scope-content",
                                                    },
                                                    [
                                                      _c(
                                                        "div",
                                                        {
                                                          staticClass:
                                                            "scpc-operate-photo",
                                                        },
                                                        [
                                                          item1.avatar &&
                                                          item1.avatar != "" &&
                                                          item1.avatar != null
                                                            ? _c("div", [
                                                                _c("img", {
                                                                  attrs: {
                                                                    src: item1.avatar,
                                                                  },
                                                                }),
                                                              ])
                                                            : _c(
                                                                "div",
                                                                {
                                                                  staticClass:
                                                                    "img",
                                                                },
                                                                [
                                                                  _vm._v(
                                                                    " " +
                                                                      _vm._s(
                                                                        item1.name.substring(
                                                                          0,
                                                                          1
                                                                        )
                                                                      ) +
                                                                      " "
                                                                  ),
                                                                ]
                                                              ),
                                                        ]
                                                      ),
                                                    ]
                                                  )
                                                }
                                              ),
                                              0
                                            ),
                                          ]
                                        ),
                                        _c(
                                          "div",
                                          {
                                            staticStyle: {
                                              display: "flex",
                                              "align-items": "center",
                                              "min-width": "55px",
                                            },
                                          },
                                          [
                                            _c(
                                              "div",
                                              {
                                                staticStyle: {
                                                  overflow: "hidden",
                                                  "text-overflow": "ellipsis",
                                                  "white-space": "nowrap",
                                                  "margin-left": "8px",
                                                },
                                              },
                                              _vm._l(
                                                scope.row[header.prop],
                                                function (item1, index) {
                                                  return _c(
                                                    "span",
                                                    { key: index },
                                                    [
                                                      _c(
                                                        "span",
                                                        {
                                                          staticClass:
                                                            "scope-content-text",
                                                        },
                                                        [
                                                          _c(
                                                            "span",
                                                            {
                                                              directives: [
                                                                {
                                                                  name: "show",
                                                                  rawName:
                                                                    "v-show",
                                                                  value:
                                                                    _vm.channel ===
                                                                    "wechat",
                                                                  expression:
                                                                    "channel === 'wechat'",
                                                                },
                                                              ],
                                                            },
                                                            [
                                                              _c(
                                                                "ww-open-data",
                                                                {
                                                                  attrs: {
                                                                    type: "userName",
                                                                    openid:
                                                                      item1.name,
                                                                  },
                                                                }
                                                              ),
                                                            ],
                                                            1
                                                          ),
                                                          _c(
                                                            "span",
                                                            {
                                                              directives: [
                                                                {
                                                                  name: "show",
                                                                  rawName:
                                                                    "v-show",
                                                                  value:
                                                                    _vm.channel !==
                                                                    "wechat",
                                                                  expression:
                                                                    "channel !== 'wechat'",
                                                                },
                                                              ],
                                                            },
                                                            [
                                                              _vm._v(
                                                                _vm._s(
                                                                  item1.name
                                                                )
                                                              ),
                                                            ]
                                                          ),
                                                          index <
                                                          scope.row[header.prop]
                                                            .length -
                                                            1
                                                            ? _c(
                                                                "span",
                                                                {
                                                                  staticStyle: {
                                                                    "margin-right":
                                                                      "5px",
                                                                  },
                                                                },
                                                                [_vm._v(",")]
                                                              )
                                                            : _vm._e(),
                                                        ]
                                                      ),
                                                    ]
                                                  )
                                                }
                                              ),
                                              0
                                            ),
                                          ]
                                        ),
                                      ]
                                    )
                                  : header.sysFlag !== "1" &&
                                    scope.row.fieldValueObject
                                  ? _c(
                                      "div",
                                      {
                                        staticStyle: {
                                          display: "flex",
                                          "align-items": "center",
                                        },
                                      },
                                      [
                                        _c(
                                          "div",
                                          {
                                            staticClass: "scpc-operate-photos",
                                          },
                                          [
                                            _c(
                                              "div",
                                              {
                                                staticStyle: {
                                                  display: "flex",
                                                  width: "6px",
                                                },
                                              },
                                              _vm._l(
                                                scope.row.fieldValueObject[
                                                  header.prop
                                                ],
                                                function (item1, index) {
                                                  return _c(
                                                    "div",
                                                    {
                                                      key: index,
                                                      staticClass:
                                                        "scope-content",
                                                    },
                                                    [
                                                      _c(
                                                        "div",
                                                        {
                                                          staticClass:
                                                            "scpc-operate-photo",
                                                        },
                                                        [
                                                          item1.avatar &&
                                                          item1.avatar != "" &&
                                                          item1.avatar != null
                                                            ? _c("div", [
                                                                _c("img", {
                                                                  attrs: {
                                                                    src: item1.avatar,
                                                                  },
                                                                }),
                                                              ])
                                                            : _c(
                                                                "div",
                                                                {
                                                                  staticClass:
                                                                    "img",
                                                                },
                                                                [
                                                                  _vm._v(
                                                                    " " +
                                                                      _vm._s(
                                                                        item1.name.substring(
                                                                          0,
                                                                          1
                                                                        )
                                                                      ) +
                                                                      " "
                                                                  ),
                                                                ]
                                                              ),
                                                        ]
                                                      ),
                                                    ]
                                                  )
                                                }
                                              ),
                                              0
                                            ),
                                          ]
                                        ),
                                        _c(
                                          "div",
                                          {
                                            staticStyle: {
                                              display: "flex",
                                              "align-items": "center",
                                              "min-width": "55px",
                                            },
                                          },
                                          [
                                            _c(
                                              "div",
                                              {
                                                staticStyle: {
                                                  overflow: "hidden",
                                                  "text-overflow": "ellipsis",
                                                  "white-space": "nowrap",
                                                  "margin-left": "8px",
                                                },
                                              },
                                              _vm._l(
                                                scope.row.fieldValueObject[
                                                  header.prop
                                                ],
                                                function (item1, index) {
                                                  return _c(
                                                    "span",
                                                    { key: index },
                                                    [
                                                      _c(
                                                        "span",
                                                        {
                                                          staticClass:
                                                            "scope-content-text",
                                                        },
                                                        [
                                                          _c(
                                                            "span",
                                                            {
                                                              directives: [
                                                                {
                                                                  name: "show",
                                                                  rawName:
                                                                    "v-show",
                                                                  value:
                                                                    _vm.channel ===
                                                                    "wechat",
                                                                  expression:
                                                                    "channel === 'wechat'",
                                                                },
                                                              ],
                                                            },
                                                            [
                                                              _c(
                                                                "ww-open-data",
                                                                {
                                                                  attrs: {
                                                                    type: "userName",
                                                                    openid:
                                                                      item1.name,
                                                                  },
                                                                }
                                                              ),
                                                            ],
                                                            1
                                                          ),
                                                          _c(
                                                            "span",
                                                            {
                                                              directives: [
                                                                {
                                                                  name: "show",
                                                                  rawName:
                                                                    "v-show",
                                                                  value:
                                                                    _vm.channel !==
                                                                    "wechat",
                                                                  expression:
                                                                    "channel !== 'wechat'",
                                                                },
                                                              ],
                                                            },
                                                            [
                                                              _vm._v(
                                                                _vm._s(
                                                                  item1.name
                                                                )
                                                              ),
                                                            ]
                                                          ),
                                                          index <
                                                          scope.row
                                                            .fieldValueObject[
                                                            header.prop
                                                          ].length -
                                                            1
                                                            ? _c(
                                                                "span",
                                                                {
                                                                  staticStyle: {
                                                                    "margin-right":
                                                                      "5px",
                                                                  },
                                                                },
                                                                [_vm._v(",")]
                                                              )
                                                            : _vm._e(),
                                                        ]
                                                      ),
                                                    ]
                                                  )
                                                }
                                              ),
                                              0
                                            ),
                                          ]
                                        ),
                                      ]
                                    )
                                  : _vm._e(),
                              ]
                            )
                          : header.type === "10"
                          ? _c("div", { staticClass: "scope-content" }, [
                              header.sysFlag === "1" && scope.row[header.prop]
                                ? _c(
                                    "div",
                                    {
                                      staticStyle: {
                                        display: "flex",
                                        "align-items": "center",
                                      },
                                    },
                                    [
                                      _c(
                                        "div",
                                        {
                                          staticClass: "scpc-operate-photo",
                                          staticStyle: {
                                            "padding-right": "2px",
                                          },
                                        },
                                        [
                                          scope.row[header.prop] &&
                                          scope.row[header.prop].avatar != "" &&
                                          scope.row[header.prop].avatar !== null
                                            ? _c("div", [
                                                _c("img", {
                                                  staticClass: "img",
                                                  attrs: {
                                                    src: scope.row[header.prop]
                                                      .avatar,
                                                  },
                                                }),
                                              ])
                                            : _c(
                                                "div",
                                                { staticClass: "img" },
                                                [
                                                  _vm._v(
                                                    " " +
                                                      _vm._s(
                                                        scope.row[
                                                          header.prop
                                                        ].name.substring(0, 1)
                                                      ) +
                                                      " "
                                                  ),
                                                ]
                                              ),
                                        ]
                                      ),
                                      _vm.channel === "wechat"
                                        ? _c(
                                            "span",
                                            {
                                              staticClass: "scope-content-text",
                                            },
                                            [
                                              _c("ww-open-data", {
                                                attrs: {
                                                  type: "userName",
                                                  openid:
                                                    scope.row[header.prop].name,
                                                },
                                              }),
                                            ],
                                            1
                                          )
                                        : _vm._e(),
                                      _vm.channel === "ding"
                                        ? _c(
                                            "span",
                                            {
                                              staticClass: "scope-content-text",
                                            },
                                            [
                                              _vm._v(
                                                _vm._s(
                                                  scope.row[header.prop].name
                                                )
                                              ),
                                            ]
                                          )
                                        : _vm._e(),
                                    ]
                                  )
                                : _vm._e(),
                              header.sysFlag === "0" && scope.row[header.prop]
                                ? _c(
                                    "div",
                                    {
                                      staticStyle: {
                                        display: "flex",
                                        "align-items": "center",
                                      },
                                    },
                                    [
                                      _c(
                                        "div",
                                        {
                                          staticClass: "scpc-operate-photo",
                                          staticStyle: {
                                            "padding-right": "2px",
                                          },
                                        },
                                        [
                                          scope.row[header.prop] &&
                                          scope.row[header.prop].avatar != "" &&
                                          scope.row[header.prop].avatar !== null
                                            ? _c("div", [
                                                _c("img", {
                                                  staticClass: "img",
                                                  attrs: {
                                                    src: scope.row[header.prop]
                                                      .avatar,
                                                  },
                                                }),
                                              ])
                                            : _c(
                                                "div",
                                                { staticClass: "img" },
                                                [
                                                  _vm._v(
                                                    " " +
                                                      _vm._s(
                                                        scope.row[
                                                          header.prop
                                                        ].name.substring(0, 1)
                                                      ) +
                                                      " "
                                                  ),
                                                ]
                                              ),
                                        ]
                                      ),
                                      _vm.channel === "wechat"
                                        ? _c(
                                            "span",
                                            {
                                              staticClass: "scope-content-text",
                                            },
                                            [
                                              _c("ww-open-data", {
                                                attrs: {
                                                  type: "userName",
                                                  openid:
                                                    scope.row[header.prop].name,
                                                },
                                              }),
                                            ],
                                            1
                                          )
                                        : _vm._e(),
                                      _vm.channel === "ding"
                                        ? _c(
                                            "span",
                                            {
                                              staticClass: "scope-content-text",
                                            },
                                            [
                                              _vm._v(
                                                _vm._s(
                                                  scope.row[header.prop].name
                                                )
                                              ),
                                            ]
                                          )
                                        : _vm._e(),
                                    ]
                                  )
                                : header.sysFlag !== "1" &&
                                  scope.row.fieldValueObject &&
                                  scope.row.fieldValueObject[header.prop]
                                ? _c(
                                    "div",
                                    {
                                      staticStyle: {
                                        display: "flex",
                                        "align-items": "center",
                                      },
                                    },
                                    [
                                      _c(
                                        "div",
                                        {
                                          staticClass: "scpc-operate-photo",
                                          staticStyle: {
                                            "padding-right": "2px",
                                          },
                                        },
                                        [
                                          scope.row.fieldValueObject[
                                            header.prop
                                          ] &&
                                          scope.row.fieldValueObject[
                                            header.prop
                                          ].avatar != "" &&
                                          scope.row.fieldValueObject[
                                            header.prop
                                          ].avatar !== null
                                            ? _c("div", [
                                                _c("img", {
                                                  staticClass: "img",
                                                  attrs: {
                                                    src: scope.row
                                                      .fieldValueObject[
                                                      header.prop
                                                    ].avatar,
                                                  },
                                                }),
                                              ])
                                            : _c(
                                                "div",
                                                { staticClass: "img" },
                                                [
                                                  _vm._v(
                                                    " " +
                                                      _vm._s(
                                                        scope.row.fieldValueObject[
                                                          header.prop
                                                        ].name.substring(0, 1)
                                                      ) +
                                                      " "
                                                  ),
                                                ]
                                              ),
                                        ]
                                      ),
                                      _vm.channel === "wechat"
                                        ? _c(
                                            "span",
                                            {
                                              staticClass: "scope-content-text",
                                            },
                                            [
                                              _c("ww-open-data", {
                                                attrs: {
                                                  type: "userName",
                                                  openid:
                                                    scope.row.fieldValueObject[
                                                      header.prop
                                                    ].name,
                                                },
                                              }),
                                            ],
                                            1
                                          )
                                        : _vm._e(),
                                      _vm.channel === "ding"
                                        ? _c(
                                            "span",
                                            {
                                              staticClass: "scope-content-text",
                                            },
                                            [
                                              _vm._v(
                                                _vm._s(
                                                  scope.row.fieldValueObject[
                                                    header.prop
                                                  ].name
                                                )
                                              ),
                                            ]
                                          )
                                        : _vm._e(),
                                    ]
                                  )
                                : _vm._e(),
                            ])
                          : header.prop === "status"
                          ? _c("div", [
                              scope.row.taskType === "1"
                                ? _c("div", { staticClass: "scope-content" }, [
                                    scope.row.status === "0" ||
                                    scope.row.status === "8"
                                      ? _c(
                                          "span",
                                          {
                                            staticClass:
                                              "tableTextColor tableTextColor1",
                                          },
                                          [_vm._v("未开始")]
                                        )
                                      : _vm._e(),
                                    scope.row.status === "1"
                                      ? _c(
                                          "span",
                                          {
                                            staticClass:
                                              "tableTextColor tableTextColor2",
                                          },
                                          [_vm._v("未完成")]
                                        )
                                      : _vm._e(),
                                    scope.row.status === "2"
                                      ? _c(
                                          "span",
                                          {
                                            staticClass:
                                              "tableTextColor tableTextColor6",
                                          },
                                          [_vm._v("已完成")]
                                        )
                                      : _vm._e(),
                                    scope.row.status === "3"
                                      ? _c(
                                          "span",
                                          {
                                            staticClass:
                                              "tableTextColor tableTextColor5",
                                          },
                                          [_vm._v("待确认")]
                                        )
                                      : _vm._e(),
                                    scope.row.status === "4"
                                      ? _c(
                                          "span",
                                          {
                                            staticClass:
                                              "tableTextColor tableTextColor7",
                                          },
                                          [_vm._v("已终止")]
                                        )
                                      : _vm._e(),
                                  ])
                                : scope.row.taskType === "0"
                                ? _c("div", { staticClass: "scope-content" }, [
                                    scope.row.status === "0"
                                      ? _c(
                                          "span",
                                          {
                                            staticClass:
                                              "tableTextColor tableTextColor1",
                                          },
                                          [_vm._v("未指派")]
                                        )
                                      : _vm._e(),
                                    scope.row.status === "1"
                                      ? _c(
                                          "span",
                                          {
                                            staticClass:
                                              "tableTextColor tableTextColor2",
                                          },
                                          [_vm._v("未完成")]
                                        )
                                      : _vm._e(),
                                    scope.row.status === "2"
                                      ? _c(
                                          "span",
                                          {
                                            staticClass:
                                              "tableTextColor tableTextColor6",
                                          },
                                          [_vm._v("已完成")]
                                        )
                                      : _vm._e(),
                                    scope.row.status === "3"
                                      ? _c(
                                          "span",
                                          {
                                            staticClass:
                                              "tableTextColor tableTextColor5",
                                          },
                                          [_vm._v("待确认")]
                                        )
                                      : _vm._e(),
                                    scope.row.status === "4"
                                      ? _c(
                                          "span",
                                          {
                                            staticClass:
                                              "tableTextColor tableTextColor7",
                                          },
                                          [_vm._v("已终止")]
                                        )
                                      : _vm._e(),
                                    scope.row.status === "8"
                                      ? _c(
                                          "span",
                                          {
                                            staticClass:
                                              "tableTextColor tableTextColor1",
                                          },
                                          [_vm._v("未开始")]
                                        )
                                      : _vm._e(),
                                  ])
                                : scope.row.proNumber
                                ? _c("div", { staticClass: "scope-content" }, [
                                    scope.row.status === "0" ||
                                    scope.row.status === "8"
                                      ? _c(
                                          "span",
                                          {
                                            staticClass:
                                              "tableTextColor tableTextColor1",
                                          },
                                          [_vm._v("未开始")]
                                        )
                                      : _vm._e(),
                                    scope.row.status === "1"
                                      ? _c(
                                          "span",
                                          {
                                            staticClass:
                                              "tableTextColor tableTextColor2",
                                          },
                                          [_vm._v("进行中")]
                                        )
                                      : _vm._e(),
                                    scope.row.status === "2"
                                      ? _c(
                                          "span",
                                          {
                                            staticClass:
                                              "tableTextColor tableTextColor6",
                                          },
                                          [_vm._v("已完成")]
                                        )
                                      : _vm._e(),
                                  ])
                                : scope.row.proTypeId === "2001"
                                ? _c("div", { staticClass: "scope-content" }, [
                                    scope.row.status === "0"
                                      ? _c(
                                          "span",
                                          {
                                            staticClass:
                                              "tableTextColor tableTextColor1",
                                          },
                                          [_vm._v("需求池")]
                                        )
                                      : _vm._e(),
                                    scope.row.status === "1"
                                      ? _c(
                                          "span",
                                          {
                                            staticClass:
                                              "tableTextColor tableTextColor2",
                                          },
                                          [_vm._v("开发中")]
                                        )
                                      : _vm._e(),
                                    scope.row.status === "5"
                                      ? _c(
                                          "span",
                                          {
                                            staticClass:
                                              "tableTextColor tableTextColor3",
                                          },
                                          [_vm._v("待测试")]
                                        )
                                      : _vm._e(),
                                    scope.row.status === "3"
                                      ? _c(
                                          "span",
                                          {
                                            staticClass:
                                              "tableTextColor tableTextColor4",
                                          },
                                          [_vm._v("测试中")]
                                        )
                                      : _vm._e(),
                                    scope.row.status === "6"
                                      ? _c(
                                          "span",
                                          {
                                            staticClass:
                                              "tableTextColor tableTextColor5",
                                          },
                                          [_vm._v("待验收")]
                                        )
                                      : _vm._e(),
                                    scope.row.status === "2"
                                      ? _c(
                                          "span",
                                          {
                                            staticClass:
                                              "tableTextColor tableTextColor6",
                                          },
                                          [_vm._v("验收完成")]
                                        )
                                      : _vm._e(),
                                    scope.row.status === "4"
                                      ? _c(
                                          "span",
                                          {
                                            staticClass:
                                              "tableTextColor tableTextColor7",
                                          },
                                          [_vm._v("已终止")]
                                        )
                                      : _vm._e(),
                                  ])
                                : scope.row.proTypeId === "0"
                                ? _c("div", { staticClass: "scope-content" }, [
                                    scope.row.status === "0"
                                      ? _c(
                                          "span",
                                          {
                                            staticClass:
                                              "tableTextColor tableTextColor1",
                                          },
                                          [_vm._v("未指派")]
                                        )
                                      : _vm._e(),
                                    scope.row.status === "1"
                                      ? _c(
                                          "span",
                                          {
                                            staticClass:
                                              "tableTextColor tableTextColor2",
                                          },
                                          [_vm._v("未完成")]
                                        )
                                      : _vm._e(),
                                    scope.row.status === "2"
                                      ? _c(
                                          "span",
                                          {
                                            staticClass:
                                              "tableTextColor tableTextColor6",
                                          },
                                          [_vm._v("已完成")]
                                        )
                                      : _vm._e(),
                                    scope.row.status === "3"
                                      ? _c(
                                          "span",
                                          {
                                            staticClass:
                                              "tableTextColor tableTextColor5",
                                          },
                                          [_vm._v("待确认")]
                                        )
                                      : _vm._e(),
                                    scope.row.status === "4"
                                      ? _c(
                                          "span",
                                          {
                                            staticClass:
                                              "tableTextColor tableTextColor7",
                                          },
                                          [_vm._v("已终止")]
                                        )
                                      : _vm._e(),
                                  ])
                                : scope.row.proTypeId === "1"
                                ? _c("div", { staticClass: "scope-content" }, [
                                    scope.row.status === "0"
                                      ? _c(
                                          "span",
                                          {
                                            staticClass:
                                              "tableTextColor tableTextColor1",
                                          },
                                          [_vm._v("未开始")]
                                        )
                                      : _vm._e(),
                                    scope.row.status === "1"
                                      ? _c(
                                          "span",
                                          {
                                            staticClass:
                                              "tableTextColor tableTextColor2",
                                          },
                                          [_vm._v("未完成")]
                                        )
                                      : _vm._e(),
                                    scope.row.status === "2"
                                      ? _c(
                                          "span",
                                          {
                                            staticClass:
                                              "tableTextColortableTextColor6",
                                          },
                                          [_vm._v("已完成")]
                                        )
                                      : _vm._e(),
                                    scope.row.status === "3"
                                      ? _c(
                                          "span",
                                          {
                                            staticClass:
                                              "tableTextColor tableTextColor5",
                                          },
                                          [_vm._v("待确认")]
                                        )
                                      : _vm._e(),
                                  ])
                                : _vm._e(),
                            ])
                          : header.type === "16"
                          ? _c(
                              "div",
                              { staticClass: "scope-content" },
                              [
                                _c("el-progress", {
                                  staticStyle: { width: "300px" },
                                  attrs: {
                                    "stroke-width": 12,
                                    percentage: scope.row.progressRate,
                                    color: "#2878ff",
                                  },
                                }),
                              ],
                              1
                            )
                          : header.type === "15"
                          ? _c(
                              "div",
                              { staticClass: "scope-content" },
                              _vm._l(
                                scope.row[header.prop],
                                function (tag, index1) {
                                  return _c(
                                    "div",
                                    { key: index1, staticClass: "info_box" },
                                    [
                                      _c(
                                        "el-tag",
                                        {
                                          staticStyle: {
                                            "margin-right": "5px",
                                          },
                                          style:
                                            "color:" +
                                            tag.color +
                                            ";background:" +
                                            _vm.convertHex(tag.color, 10),
                                          attrs: { type: "warning" },
                                        },
                                        [_vm._v(_vm._s(tag.labelName))]
                                      ),
                                    ],
                                    1
                                  )
                                }
                              ),
                              0
                            )
                          : header.type === "0" || header.type === "1"
                          ? _c("div", { staticClass: "scope-content" }, [
                              header.sysFlag == "1"
                                ? _c(
                                    "span",
                                    { staticClass: "scope-content-text" },
                                    [
                                      _vm._v(
                                        " " +
                                          _vm._s(scope.row[header.prop]) +
                                          " "
                                      ),
                                      header.type === "1" &&
                                      scope.row[header.prop] !== "" &&
                                      scope.row[header.prop] !== null
                                        ? _c("span", [
                                            _vm._v(_vm._s(header.unit)),
                                          ])
                                        : _vm._e(),
                                    ]
                                  )
                                : _vm._e(),
                              header.sysFlag == "0" &&
                              header.clickData &&
                              header.clickData.idMapping !== null
                                ? _c(
                                    "span",
                                    {
                                      staticClass: "scope-content-text",
                                      staticStyle: {
                                        cursor: "pointer",
                                        color: "#2878ff",
                                      },
                                      on: {
                                        click: function ($event) {
                                          $event.stopPropagation()
                                          return _vm.handleCellClick(
                                            scope.row,
                                            header
                                          )
                                        },
                                      },
                                    },
                                    [
                                      _vm._v(
                                        " " +
                                          _vm._s(scope.row[header.prop]) +
                                          " "
                                      ),
                                    ]
                                  )
                                : _vm._e(),
                              header.sysFlag == "0" &&
                              !(
                                header.clickData &&
                                header.clickData.idMapping !== null
                              )
                                ? _c(
                                    "span",
                                    { staticClass: "scope-content-text" },
                                    [
                                      _vm._v(
                                        " " +
                                          _vm._s(scope.row[header.prop]) +
                                          " "
                                      ),
                                    ]
                                  )
                                : _vm._e(),
                              header.sysFlag !== "1" &&
                              scope.row.fieldValueObject
                                ? _c("span", [
                                    _c(
                                      "span",
                                      { staticClass: "scope-content-text" },
                                      [
                                        _vm._v(
                                          _vm._s(
                                            scope.row.fieldValueObject[
                                              header.prop
                                            ]
                                          ) + " "
                                        ),
                                        header.type === "1" &&
                                        scope.row.fieldValueObject[
                                          header.prop
                                        ] !== "" &&
                                        scope.row.fieldValueObject[
                                          header.prop
                                        ] !== null
                                          ? _c("span", [
                                              _vm._v(_vm._s(header.unit)),
                                            ])
                                          : _vm._e(),
                                      ]
                                    ),
                                  ])
                                : _vm._e(),
                            ])
                          : header.type === "4"
                          ? _c("div", { staticClass: "scope-content" }, [
                              header.sysFlag == "1"
                                ? _c(
                                    "span",
                                    { staticClass: "scope-content-text" },
                                    [
                                      header.unit === "10" &&
                                      scope.row[header.prop]
                                        ? _c("span", [
                                            _vm._v(
                                              " " +
                                                _vm._s(
                                                  scope.row[
                                                    header.prop
                                                  ].substring(0, 10)
                                                ) +
                                                " "
                                            ),
                                          ])
                                        : _c("span", [
                                            _vm._v(
                                              " " +
                                                _vm._s(scope.row[header.prop]) +
                                                " "
                                            ),
                                          ]),
                                    ]
                                  )
                                : _vm._e(),
                              header.sysFlag == "0"
                                ? _c(
                                    "span",
                                    { staticClass: "scope-content-text" },
                                    [
                                      _vm._v(
                                        " " +
                                          _vm._s(scope.row[header.prop]) +
                                          " "
                                      ),
                                    ]
                                  )
                                : _vm._e(),
                              header.sysFlag !== "1" &&
                              scope.row.fieldValueObject
                                ? _c("span", [
                                    _c(
                                      "span",
                                      { staticClass: "scope-content-text" },
                                      [
                                        header.unit === "10" &&
                                        scope.row.fieldValueObject[header.prop]
                                          ? _c("span", [
                                              _vm._v(
                                                " " +
                                                  _vm._s(
                                                    scope.row.fieldValueObject[
                                                      header.prop
                                                    ].substring(0, 10)
                                                  ) +
                                                  " "
                                              ),
                                            ])
                                          : _c("span", [
                                              _vm._v(
                                                " " +
                                                  _vm._s(
                                                    scope.row.fieldValueObject[
                                                      header.prop
                                                    ]
                                                  ) +
                                                  " "
                                              ),
                                            ]),
                                      ]
                                    ),
                                  ])
                                : _vm._e(),
                            ])
                          : header.type === "2"
                          ? _c(
                              "div",
                              {
                                staticClass: "scope-content",
                                staticStyle: { cursor: "pointer" },
                              },
                              [
                                header.sysFlag === "1"
                                  ? _c(
                                      "div",
                                      [
                                        _c(
                                          "el-popover",
                                          {
                                            ref: "popverRef",
                                            refInFor: true,
                                            attrs: {
                                              placement: "bottom-start",
                                              width: "140",
                                              trigger: "hover",
                                            },
                                          },
                                          [
                                            _c("div", [
                                              _vm._v(
                                                " " +
                                                  _vm._s(
                                                    scope.row[header.prop]
                                                  ) +
                                                  " "
                                              ),
                                            ]),
                                            scope.row.fileList &&
                                            scope.row.fileList.length > 0
                                              ? _c(
                                                  "div",
                                                  { staticClass: "file_lists" },
                                                  _vm._l(
                                                    scope.row.fileList,
                                                    function (
                                                      file,
                                                      index_file
                                                    ) {
                                                      return _c(
                                                        "div",
                                                        {
                                                          key: index_file,
                                                          staticClass:
                                                            "file_boxs",
                                                        },
                                                        [
                                                          _c(
                                                            "div",
                                                            {
                                                              staticClass:
                                                                "file_text",
                                                              on: {
                                                                click:
                                                                  function (
                                                                    $event
                                                                  ) {
                                                                    $event.stopPropagation()
                                                                    return _vm.previewFile(
                                                                      file
                                                                    )
                                                                  },
                                                              },
                                                            },
                                                            [
                                                              _c("i", {
                                                                staticClass:
                                                                  "iconfont icon-wenjian file__icon",
                                                              }),
                                                              _c(
                                                                "span",
                                                                {
                                                                  staticClass:
                                                                    "file_text_name",
                                                                },
                                                                [
                                                                  _vm._v(
                                                                    _vm._s(
                                                                      file.fileName
                                                                    )
                                                                  ),
                                                                ]
                                                              ),
                                                            ]
                                                          ),
                                                        ]
                                                      )
                                                    }
                                                  ),
                                                  0
                                                )
                                              : _vm._e(),
                                            _c(
                                              "span",
                                              {
                                                attrs: { slot: "reference" },
                                                slot: "reference",
                                              },
                                              [
                                                ["", null, undefined].indexOf(
                                                  scope.row[header.prop]
                                                ) === -1
                                                  ? _c(
                                                      "span",
                                                      [
                                                        _c(
                                                          "el-tooltip",
                                                          {
                                                            attrs: {
                                                              effect: "dark",
                                                              content:
                                                                scope.row[
                                                                  header.prop
                                                                ],
                                                              placement: "top",
                                                              "popper-class":
                                                                "texttooltip",
                                                              "open-delay": 500,
                                                            },
                                                          },
                                                          [
                                                            _c(
                                                              "span",
                                                              {
                                                                staticClass:
                                                                  "scope-content-text",
                                                              },
                                                              [
                                                                scope.row
                                                                  .fileList &&
                                                                scope.row
                                                                  .fileList
                                                                  .length > 0
                                                                  ? _c("i", {
                                                                      staticClass:
                                                                        "iconfont icon-wenjian file__icon",
                                                                    })
                                                                  : _vm._e(),
                                                                _vm._v(
                                                                  " " +
                                                                    _vm._s(
                                                                      scope.row[
                                                                        header
                                                                          .prop
                                                                      ]
                                                                    ) +
                                                                    " "
                                                                ),
                                                              ]
                                                            ),
                                                          ]
                                                        ),
                                                      ],
                                                      1
                                                    )
                                                  : scope.row.fileList &&
                                                    scope.row.fileList.length >
                                                      0
                                                  ? _c("span", [
                                                      _c("i", {
                                                        staticClass:
                                                          "iconfont icon-wenjian file__icon",
                                                      }),
                                                    ])
                                                  : _vm._e(),
                                              ]
                                            ),
                                          ]
                                        ),
                                      ],
                                      1
                                    )
                                  : header.sysFlag !== "1" &&
                                    scope.row.fieldValueObject &&
                                    scope.row.fieldValueObject[header.prop]
                                  ? _c(
                                      "div",
                                      [
                                        _c(
                                          "el-popover",
                                          {
                                            ref: "popverRef",
                                            refInFor: true,
                                            staticStyle: {
                                              overflow: "hidden",
                                              "text-overflow": "ellipsis",
                                              "white-space": "nowrap",
                                              "margin-right": "10px",
                                            },
                                            attrs: {
                                              placement: "bottom-start",
                                              width: "140",
                                              trigger: "hover",
                                            },
                                          },
                                          [
                                            _c(
                                              "div",
                                              {
                                                staticStyle: {
                                                  padding: "5px 0",
                                                },
                                              },
                                              [
                                                _vm._v(
                                                  " " +
                                                    _vm._s(
                                                      scope.row
                                                        .fieldValueObject[
                                                        header.prop
                                                      ].content
                                                    ) +
                                                    " "
                                                ),
                                              ]
                                            ),
                                            scope.row.fieldValueObject[
                                              header.prop
                                            ].fileList &&
                                            scope.row.fieldValueObject[
                                              header.prop
                                            ].fileList.length > 0
                                              ? _c(
                                                  "div",
                                                  { staticClass: "file_lists" },
                                                  _vm._l(
                                                    scope.row.fieldValueObject[
                                                      header.prop
                                                    ].fileList,
                                                    function (
                                                      file,
                                                      index_file
                                                    ) {
                                                      return _c(
                                                        "div",
                                                        {
                                                          key: index_file,
                                                          staticClass:
                                                            "file_boxs",
                                                        },
                                                        [
                                                          _c(
                                                            "div",
                                                            {
                                                              staticClass:
                                                                "file_text",
                                                              on: {
                                                                click:
                                                                  function (
                                                                    $event
                                                                  ) {
                                                                    $event.stopPropagation()
                                                                    return _vm.previewFile(
                                                                      file
                                                                    )
                                                                  },
                                                              },
                                                            },
                                                            [
                                                              _c("i", {
                                                                staticClass:
                                                                  "iconfont icon-wenjian file__icon",
                                                              }),
                                                              _c(
                                                                "span",
                                                                {
                                                                  staticClass:
                                                                    "file_text_name",
                                                                },
                                                                [
                                                                  _vm._v(
                                                                    _vm._s(
                                                                      file.fileName
                                                                    )
                                                                  ),
                                                                ]
                                                              ),
                                                            ]
                                                          ),
                                                        ]
                                                      )
                                                    }
                                                  ),
                                                  0
                                                )
                                              : _vm._e(),
                                            _c(
                                              "span",
                                              {
                                                staticClass:
                                                  "scope-content-text",
                                                attrs: { slot: "reference" },
                                                slot: "reference",
                                              },
                                              [
                                                ["", null, undefined].indexOf(
                                                  scope.row.fieldValueObject[
                                                    header.prop
                                                  ].content
                                                ) === -1
                                                  ? _c(
                                                      "span",
                                                      [
                                                        _c(
                                                          "el-tooltip",
                                                          {
                                                            attrs: {
                                                              effect: "dark",
                                                              content:
                                                                scope.row
                                                                  .fieldValueObject[
                                                                  header.prop
                                                                ].content,
                                                              placement: "top",
                                                              "popper-class":
                                                                "texttooltip",
                                                              "open-delay": 500,
                                                            },
                                                          },
                                                          [
                                                            _c("span", [
                                                              scope.row
                                                                .fieldValueObject[
                                                                header.prop
                                                              ].fileList &&
                                                              scope.row
                                                                .fieldValueObject[
                                                                header.prop
                                                              ].fileList
                                                                .length > 0
                                                                ? _c("i", {
                                                                    staticClass:
                                                                      "iconfont icon-wenjian file__icon",
                                                                  })
                                                                : _vm._e(),
                                                              _vm._v(
                                                                " " +
                                                                  _vm._s(
                                                                    scope.row
                                                                      .fieldValueObject[
                                                                      header
                                                                        .prop
                                                                    ].content
                                                                  ) +
                                                                  " "
                                                              ),
                                                            ]),
                                                          ]
                                                        ),
                                                      ],
                                                      1
                                                    )
                                                  : _c("span", [
                                                      _c("i", {
                                                        staticClass:
                                                          "iconfont icon-wenjian file__icon",
                                                      }),
                                                    ]),
                                              ]
                                            ),
                                          ]
                                        ),
                                      ],
                                      1
                                    )
                                  : _vm._e(),
                              ]
                            )
                          : header.type === "3" &&
                            scope.row.fieldValueObject &&
                            scope.row.fieldValueObject[header.prop]
                          ? _c(
                              "div",
                              {
                                staticClass: "scope-content",
                                staticStyle: { cursor: "pointer" },
                              },
                              [
                                _c(
                                  "el-popover",
                                  {
                                    ref: "popverRef",
                                    refInFor: true,
                                    staticStyle: {
                                      overflow: "hidden",
                                      "text-overflow": "ellipsis",
                                      "white-space": "nowrap",
                                      "margin-right": "10px",
                                    },
                                    attrs: {
                                      placement: "bottom-start",
                                      width: "140",
                                      trigger: "hover",
                                    },
                                  },
                                  [
                                    scope.row.fieldValueObject[header.prop] &&
                                    scope.row.fieldValueObject[header.prop]
                                      .length > 0
                                      ? _c(
                                          "div",
                                          { staticClass: "file_lists" },
                                          _vm._l(
                                            scope.row.fieldValueObject[
                                              header.prop
                                            ],
                                            function (file, index_file) {
                                              return _c(
                                                "div",
                                                {
                                                  key: index_file,
                                                  staticClass: "file_boxs",
                                                },
                                                [
                                                  _c(
                                                    "div",
                                                    {
                                                      staticClass: "file_text",
                                                      on: {
                                                        click: function (
                                                          $event
                                                        ) {
                                                          $event.stopPropagation()
                                                          return _vm.previewFile(
                                                            file
                                                          )
                                                        },
                                                      },
                                                    },
                                                    [
                                                      _c("i", {
                                                        staticClass:
                                                          "iconfont icon-wenjian file__icon",
                                                      }),
                                                      _c(
                                                        "span",
                                                        {
                                                          staticClass:
                                                            "file_text_name",
                                                        },
                                                        [
                                                          _vm._v(
                                                            _vm._s(
                                                              file.fileName
                                                            )
                                                          ),
                                                        ]
                                                      ),
                                                    ]
                                                  ),
                                                ]
                                              )
                                            }
                                          ),
                                          0
                                        )
                                      : _vm._e(),
                                    _c(
                                      "span",
                                      {
                                        staticClass: "scope-content-text",
                                        attrs: { slot: "reference" },
                                        slot: "reference",
                                      },
                                      [
                                        _c(
                                          "el-tooltip",
                                          {
                                            attrs: {
                                              effect: "dark",
                                              content:
                                                scope.row.fieldValueObject[
                                                  header.prop
                                                ].length + "个文件",
                                              placement: "top",
                                              "popper-class": "texttooltip",
                                              "open-delay": 500,
                                            },
                                          },
                                          [
                                            scope.row.fieldValueObject[
                                              header.prop
                                            ] &&
                                            scope.row.fieldValueObject[
                                              header.prop
                                            ].length > 0
                                              ? _c("i", {
                                                  staticClass:
                                                    "iconfont icon-wenjian file__icon",
                                                })
                                              : _vm._e(),
                                          ]
                                        ),
                                      ],
                                      1
                                    ),
                                  ]
                                ),
                              ],
                              1
                            )
                          : header.type === "5" &&
                            scope.row.fieldValueObject &&
                            scope.row.fieldValueObject[header.prop]
                          ? _c("div", { staticClass: "scope-content" }, [
                              _c(
                                "span",
                                { staticClass: "scope-content-text" },
                                [
                                  _vm._v(
                                    _vm._s(
                                      JSON.parse(
                                        scope.row.fieldValueObject[header.prop]
                                      ).addressName
                                    )
                                  ),
                                ]
                              ),
                            ])
                          : header.type === "6" || header.type === "8"
                          ? _c(
                              "div",
                              { staticClass: "scope-content" },
                              _vm._l(header.options, function (I, index3) {
                                return _c("div", { key: index3 }, [
                                  scope.row[header.prop] === I.key &&
                                  header.sysFlag === "1"
                                    ? _c(
                                        "span",
                                        { staticClass: "scope-content-text" },
                                        [_vm._v(_vm._s(I.name))]
                                      )
                                    : scope.row.fieldValueObject
                                    ? _c("span", [
                                        scope.row.fieldValueObject[
                                          header.prop
                                        ] === I.key
                                          ? _c(
                                              "span",
                                              {
                                                staticClass:
                                                  "scope-content-text",
                                              },
                                              [_vm._v(_vm._s(I.value))]
                                            )
                                          : _vm._e(),
                                      ])
                                    : _vm._e(),
                                ])
                              }),
                              0
                            )
                          : (header.type === "7" || header.type === "9") &&
                            scope.row.fieldValueObject &&
                            scope.row.fieldValueObject[header.prop]
                          ? _c(
                              "div",
                              { staticClass: "scope-content" },
                              _vm._l(
                                _vm.getSelectList(
                                  scope.row.fieldValueObject[header.prop],
                                  header.options
                                ),
                                function (I, index3) {
                                  return _c("div", { key: index3 }, [
                                    _c("span", [_vm._v(_vm._s(I.value))]),
                                    index3 !==
                                    _vm.getSelectList(
                                      scope.row.fieldValueObject[header.prop],
                                      header.options
                                    ).length -
                                      1
                                      ? _c("span", [_vm._v(",")])
                                      : _vm._e(),
                                  ])
                                }
                              ),
                              0
                            )
                          : header.type === "19"
                          ? _c(
                              "div",
                              { staticClass: "scope-content" },
                              _vm._l(
                                scope.row[header.prop],
                                function (I, index3) {
                                  return _c(
                                    "div",
                                    {
                                      key: index3,
                                      staticStyle: { "margin-right": "10px" },
                                      on: {
                                        click: function ($event) {
                                          $event.stopPropagation()
                                          return _vm.deleteModule(
                                            scope.row,
                                            scope.$index,
                                            I.actionType
                                          )
                                        },
                                      },
                                    },
                                    [
                                      _c(
                                        "el-button",
                                        {
                                          staticStyle: {
                                            "line-height": "10px !important",
                                          },
                                        },
                                        [_vm._v(_vm._s(I.name))]
                                      ),
                                    ],
                                    1
                                  )
                                }
                              ),
                              0
                            )
                          : _c("div", { staticClass: "scope-content-id" }, [
                              _vm._v(
                                " " + _vm._s(scope.row[header.prop]) + " "
                              ),
                              header.unit
                                ? _c("span", [_vm._v(_vm._s(header.unit))])
                                : _vm._e(),
                            ]),
                      ]
                    },
                  },
                ],
                null,
                true
              ),
            })
          }),
          _vm.tabType !== "deta"
            ? _c(
                "el-table-column",
                {
                  attrs: {
                    prop: "totalPurchase",
                    label: "",
                    width: "50px",
                    fixed: "right",
                  },
                },
                [
                  _c(
                    "template",
                    { slot: "header" },
                    [
                      _c(
                        "el-popover",
                        {
                          ref: "popover",
                          attrs: {
                            placement: "bottom",
                            width: "330",
                            trigger: "hover",
                          },
                          on: { show: _vm.showPopver },
                        },
                        [
                          _c(
                            "div",
                            {
                              directives: [
                                {
                                  name: "infinite-scroll",
                                  rawName: "v-infinite-scroll",
                                  value: _vm.load,
                                  expression: "load",
                                },
                              ],
                              staticClass: "filter-box",
                              attrs: { "infinite-scroll-distance": "15" },
                              on: { scroll: _vm.handleScroll },
                            },
                            [
                              _c(
                                "div",
                                { staticClass: "filter-box-sub" },
                                [
                                  _c(
                                    "div",
                                    { staticClass: "filter-ones title" },
                                    [
                                      _vm._v(" 已选字段 "),
                                      _c("el-input", {
                                        attrs: {
                                          placeholder: "请输入字段名称",
                                          "suffix-icon": "el-icon-search",
                                        },
                                        on: { input: _vm.filedsValueChange },
                                        model: {
                                          value: _vm.filedsValue,
                                          callback: function ($$v) {
                                            _vm.filedsValue = $$v
                                          },
                                          expression: "filedsValue",
                                        },
                                      }),
                                    ],
                                    1
                                  ),
                                  _vm.checkList
                                    ? _c(
                                        "draggable",
                                        {
                                          attrs: {
                                            group: "serviceUserList",
                                            options: {
                                              handle: ".form_draggable",
                                            },
                                            animation: "500",
                                          },
                                          on: {
                                            end: function ($event) {
                                              return _vm.taskcheck(
                                                _vm.checkList
                                              )
                                            },
                                          },
                                          model: {
                                            value: _vm.checkList,
                                            callback: function ($$v) {
                                              _vm.checkList = $$v
                                            },
                                            expression: "checkList",
                                          },
                                        },
                                        [
                                          _c(
                                            "transition-group",
                                            {
                                              staticStyle: {
                                                "flex-wrap": "wrap",
                                                display: "inline-block",
                                                width: "100%",
                                              },
                                            },
                                            _vm._l(
                                              _vm.checkList,
                                              function (item2, index2) {
                                                return _c(
                                                  "div",
                                                  {
                                                    key: index2,
                                                    staticClass:
                                                      "mode-dragula projectTabs",
                                                    staticStyle: {
                                                      "padding-bottom": "10px",
                                                    },
                                                  },
                                                  [
                                                    _c(
                                                      "div",
                                                      {
                                                        staticClass: "mode-one",
                                                        staticStyle: {
                                                          cursor: "pointer",
                                                        },
                                                      },
                                                      [
                                                        _c("i", {
                                                          staticClass:
                                                            "iconfont icon-shangxia form_draggable",
                                                          staticStyle: {
                                                            "margin-right":
                                                              "14px",
                                                            cursor: "pointer",
                                                            color:
                                                              "rgb(204, 204, 204)",
                                                          },
                                                        }),
                                                        _c(
                                                          "span",
                                                          {
                                                            staticStyle: {
                                                              flex: "1 1 auto",
                                                              overflow:
                                                                "hidden",
                                                              "text-overflow":
                                                                "ellipsis",
                                                              "white-space":
                                                                "nowrap",
                                                            },
                                                          },
                                                          [
                                                            _vm._v(
                                                              " " +
                                                                _vm._s(
                                                                  item2.label
                                                                ) +
                                                                " "
                                                            ),
                                                          ]
                                                        ),
                                                        _c("el-checkbox", {
                                                          attrs: {
                                                            "true-label": "1",
                                                            "false-label": "0",
                                                            disabled:
                                                              item2.prop ===
                                                                "taskname" ||
                                                              item2.prop ===
                                                                "proname"
                                                                ? true
                                                                : false,
                                                          },
                                                          on: {
                                                            change: function (
                                                              $event
                                                            ) {
                                                              return _vm.editFormData1(
                                                                item2,
                                                                index2
                                                              )
                                                            },
                                                          },
                                                          model: {
                                                            value:
                                                              item2.checkFlag,
                                                            callback: function (
                                                              $$v
                                                            ) {
                                                              _vm.$set(
                                                                item2,
                                                                "checkFlag",
                                                                $$v
                                                              )
                                                            },
                                                            expression:
                                                              "item2.checkFlag",
                                                          },
                                                        }),
                                                      ],
                                                      1
                                                    ),
                                                  ]
                                                )
                                              }
                                            ),
                                            0
                                          ),
                                        ],
                                        1
                                      )
                                    : _vm._e(),
                                ],
                                1
                              ),
                              _c("div", { staticClass: "filter-box-sub" }, [
                                _c(
                                  "div",
                                  { staticClass: "filter-ones title" },
                                  [_vm._v("未选字段")]
                                ),
                                _c(
                                  "div",
                                  _vm._l(
                                    _vm.uncheckList,
                                    function (item, index1) {
                                      return _c(
                                        "div",
                                        {
                                          key: index1,
                                          staticClass:
                                            "mode-dragula projectTabs",
                                          staticStyle: {
                                            "padding-bottom": "10px",
                                          },
                                        },
                                        [
                                          _c(
                                            "div",
                                            {
                                              staticClass: "mode-one",
                                              staticStyle: {
                                                cursor: "pointer",
                                              },
                                            },
                                            [
                                              _c("i", {
                                                staticClass:
                                                  "iconfont icon-shangxia",
                                                staticStyle: {
                                                  "margin-right": "14px",
                                                  cursor: "pointer",
                                                  color: "rgb(204, 204, 204)",
                                                },
                                              }),
                                              _c(
                                                "span",
                                                {
                                                  staticStyle: {
                                                    flex: "1 1 auto",
                                                    overflow: "hidden",
                                                    "text-overflow": "ellipsis",
                                                    "white-space": "nowrap",
                                                    cursor: "pointer",
                                                  },
                                                },
                                                [
                                                  _vm._v(
                                                    " " +
                                                      _vm._s(item.label) +
                                                      " "
                                                  ),
                                                ]
                                              ),
                                              _c("el-checkbox", {
                                                attrs: {
                                                  "true-label": "1",
                                                  "false-label": "0",
                                                },
                                                on: {
                                                  change: function ($event) {
                                                    return _vm.editFormData(
                                                      item,
                                                      index1
                                                    )
                                                  },
                                                },
                                                model: {
                                                  value: item.checkFlag,
                                                  callback: function ($$v) {
                                                    _vm.$set(
                                                      item,
                                                      "checkFlag",
                                                      $$v
                                                    )
                                                  },
                                                  expression: "item.checkFlag",
                                                },
                                              }),
                                            ],
                                            1
                                          ),
                                        ]
                                      )
                                    }
                                  ),
                                  0
                                ),
                              ]),
                            ]
                          ),
                          _c(
                            "span",
                            { attrs: { slot: "reference" }, slot: "reference" },
                            [
                              _c("i", {
                                staticClass:
                                  "iconfont icon-shezhi-xianxing form_name_icon",
                                staticStyle: {
                                  cursor: "pointer",
                                  "font-size": "19px",
                                },
                              }),
                            ]
                          ),
                        ]
                      ),
                    ],
                    1
                  ),
                ],
                2
              )
            : _vm._e(),
        ],
        2
      ),
      _c("VideoPreview", {
        attrs: { visible: _vm.showVideo, url: _vm.videoUrl },
        on: {
          "update:visible": [
            function ($event) {
              _vm.showVideo = $event
            },
            function (val) {
              return _vm.console.log("visible 更新为:", val)
            },
          ],
        },
      }),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }